import env from '../config/env';
import keycloak from '../config/keycloak';

class RoleService {
  /**
   * Checks if the current user has the 'codex_insert' realm role.
   * The role is considered present if Keycloak authentication is disabled
   * or if the user explicitly has the 'codex_insert' role.
   * @returns {boolean} True if the user has the role, false otherwise.
   */
  hasCodexInsertRole() {
    return !env.useKeycloakAuth || keycloak.hasRealmRole('codex_insert');
  }

  /**
   * Checks if the current user has either 'queue_view_all' or 'queue_view_own' realm roles,
   * or if Keycloak authentication is disabled.
   * @returns {boolean} True if the user has appropriate queue view roles or auth is disabled, false otherwise.
   */
  hasQueueViewRole() {
    return !env.useKeycloakAuth || 
           keycloak.hasRealmRole('queue_view_all') || 
           keycloak.hasRealmRole('queue_view_own');
  }

  /**
   * Checks if the current user has the 'config_manage' realm role,
   * or if Keycloak authentication is disabled.
   * @returns {boolean} True if the user has the role or auth is disabled, false otherwise.
   */
  hasConfigManageRole() {
    return !env.useKeycloakAuth || keycloak.hasRealmRole('config_manage');
  }

  /**
   * Checks if the current user has the 'config_advanced' realm role,
   * or if Keycloak authentication is disabled.
   * @returns {boolean} True if the user has the role or auth is disabled, false otherwise.
   */
  hasConfigAdvancedRole() {
    return !env.useKeycloakAuth || keycloak.hasRealmRole('config_advanced');
  }
}

export default new RoleService(); 